import { loadKeyFromSessionStorage, saveKeyToSessionStorage } from '../../../common/utils/utils';

export function loadDashboardSortingConfiguration(folderName) {
    return loadKeyFromSessionStorage(`dashboardSortingConfiguration-${folderName}`);
}

export function saveDashboardSortingConfiguration(folderName, sortObj) {
    return saveKeyToSessionStorage(
        `dashboardSortingConfiguration-${folderName}`,
        sortObj,
    );
}
